/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface SessionQueryDto
 */
export interface SessionQueryDto {

    /**
     * When true returns only soft-deleted rows. When omitted or false, only live rows. Restore-by-id is unchanged.
     *
     * @type {boolean}
     * @memberof SessionQueryDto
     */
    deleted?: boolean;

    /**
     * When true returns { data, meta } paginated response. When false (default) returns a plain array of all matching records ignoring page/limit.
     *
     * @type {boolean}
     * @memberof SessionQueryDto
     */
    paginated?: boolean;

    /**
     * Page number (1-based)
     *
     * @type {number}
     * @memberof SessionQueryDto
     * @example 1
     */
    page?: number;

    /**
     * Filter by template status. When omitted, no template filter is applied.
     *
     * @type {boolean}
     * @memberof SessionQueryDto
     */
    isTemplate?: boolean;

    /**
     * Number of records per page
     *
     * @type {number}
     * @memberof SessionQueryDto
     * @example 10
     */
    limit?: number;

    /**
     * Filter sessions by mobility level id. When omitted, no mobility filter is applied.
     *
     * @type {number}
     * @memberof SessionQueryDto
     */
    mobilityId?: number;
}
